import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'


export const validatePhoneNumber = (value) => {
  if (!value) {
    return 'Veuillez indiquer le numéro de téléphone.'
  }

  try {
    const phoneWithPlus = value.startsWith('+') ? value : `+${value}`

    if (!isValidPhoneNumber(phoneWithPlus)) {
      return 'Numéro de téléphone invalide'
    }

    const phoneNumber = parsePhoneNumber(phoneWithPlus)

    if (!phoneNumber.isPossible()) {
      return 'Numéro de téléphone invalide'
    }

    return true
  } catch (error) {
    return 'Numéro de téléphone invalide'
  }
}
